"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraUpload = void 0;
const React = require("react");
const react_1 = require("react");
const CameraUploadContext_1 = require("../../../../contexts/CameraUploadContext");
const Camera_1 = require("../Camera");
const axios_1 = require("axios");
const CameraPreview_1 = require("../Camera/components/CameraPreview");
/**
 * The CameraUpload component wraps the Camera component, and should be wrapped in a context (CameraUploadContext),
 * which contains methods that relate to uploading and getting the image.
 *
 * This component will call the `onChange` prop when a new image has been taken
 * The contents of the `value` prop should be a fileKey, that directly relates to the image stored in a Bucket,
 * The CameraUpload component will then use the methods provided by the context to get a "signed" url of the image,
 * this url is then passed directly to the Camera component, which will instead of showing the camera, render the image.
 */
const CameraUpload = (_a) => {
    var { onChange, value = null, uploadNamespace } = _a, props = __rest(_a, ["onChange", "value", "uploadNamespace"]);
    const context = (0, react_1.useContext)(CameraUploadContext_1.CameraUploadContext);
    const [uploading, setUploading] = (0, react_1.useState)(false);
    /**
     * If a value is passed in on the first render, we know we are getting the value,
     * therefore set gettingUrl to true, which will in turn not show the Camera Component yet.
     */
    const [gettingUrl, setGettingUrl] = (0, react_1.useState)(!!value);
    const [image, setImage] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (value === null) {
            // if the input has been cleared.
            if (image !== null) {
                setImage(null);
            }
            return;
        }
        if (value !== null) {
            setGettingUrl(true);
            (async () => {
                const url = await context.getSignedImageUrl(value);
                setImage(url);
                setGettingUrl(false);
                // tslint:disable-next-line:no-console
            })().catch(console.error);
        }
    }, [value]);
    if (image || gettingUrl || uploading) {
        const style = {
            height: props.videoWidth,
            width: props.videoWidth
        };
        return (React.createElement("div", { style: style },
            React.createElement(CameraPreview_1.CameraPreview, { image: image, round: props.isRoundStyle })));
    }
    const customProps = Object.assign(Object.assign({}, props), { returnType: "blob", onPhotoTaken: async (newImage) => {
            setUploading(true);
            const { url, headers, method, fileKey: key } = await context.getUploadDetails(uploadNamespace);
            await (0, axios_1.default)({
                method,
                url,
                headers,
                data: newImage
            });
            onChange(key);
            setUploading(false);
        } });
    return React.createElement(Camera_1.Camera, Object.assign({}, customProps));
};
exports.CameraUpload = CameraUpload;
//# sourceMappingURL=index.js.map